import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { routes } from "./constants/routes";
import LoaderFile from "./loader/LoaderFile";

import ResetPassword from "./auth/ResetPassword";
import PrivateRoutes from "./utils/PrivateRoutes";
import Dashboard from "./layout/Dashboard";
import AdminLogin from "./auth/AdminLogin";
import NotFound from "./layout/NotFound";
import AdminLayout from "./layout/Admin/AdminLayout";
import MainLayout from "./layout/MainLayout";
import Profile from "./layout/Admin/Profile";

import InquiryList from "./feature/admin/Inquiry/InquiryList";
import EventCategory from "./feature/admin/EventCategory/EventCategory";
import UserEmailVerification from "./auth/UserEmailVerification";
import DocumentTypeMaster from "./feature/admin/DocumentType/DocumentTypeList";
import HomePage from "./layout/HomePage";
import Subscription from "./feature/admin/Subscription/Subscription";
import Inquiry from "./feature/Common/Inquiry";
import AccountDashboard from "./feature/Organizer/AccountDashbard";
import AccountHeader from "./feature/Common/AccountHeader";
import SubscriptionList from "./feature/Organizer/SubscriptionList";
import BusinessProfile from "./feature/Profile/BusinessProfile";
import PersonalInfo from "./feature/Profile/PersonalInfo";
import CreateEvent from "./feature/Event/CreateEvent";
import EventList from "./feature/Event/EventList";
import ActiveSubscription from "./feature/Organizer/ActiveSubscription";
import EventPage from "./feature/Event/Event-Page";
import EventDashboard from "./feature/Event/Event-Dashboard";
import CreatePitch from "./feature/Event/Pitch/Create-Pitch";
import AddEventApplication from "./feature/Event/Application/AddEventApplication";
import PitchDetails from "./feature/Event/Pitch/Pitch-Details";
import ApplicationLanding from "./feature/Event/Application/ApplicationLanding";
import RetailApplicationForm from "./feature/Event/Retail/RetailApplicationForm";
import GlobalSettings from "./feature/admin/GlobalSettings/GlobalSettings";
import CaterApplicationForm from "./feature/Event/Application/Cater/CaterApplicationForm";
import VerifyCodePopup from "./auth/VerifyCodePopup";
import "./App.css";
import EventsListPage from "./layout/Events/EventsListPage";
import ScrollToTop from "./components/Common/ScrollToTop";
import ApplicationList from "./feature/Event/Application/ApplicationList";
//import useScript from "./hooks/useScript";
import Contract from "./feature/admin/Contract/ManageContractlist";
// import audienceUpdates from "./feature/admin/"
import EventContract from "./feature/Event/Contract/Event-Contract";
import EditEventContact from "./feature/Event/Contract/Create-Contract";
import EventDocument from "./feature/Event/Document/Event-Document";
import CreateDocument from "./feature/Event/Document/Create-Document";
import EventMap from "./feature/Event/Map/Event-Map";
import EventCatererSubmissionList from "./feature/Organizer/SubmissionList/CatererSubmissionList";
import EventTraderSubmissionList from "./feature/Organizer/SubmissionList/RetailerSubmissionList";
import EventCatererSubmissionDetails from "./feature/Organizer/SubmissionList/CatererSubmissionDetails";
import EventRetailerSubmissionDetails from "./feature/Organizer/SubmissionList/RetailerSubmissionDetails";
import EventOrganizerList from "./feature/admin/EventOrganizer/EventOrganizerList";
import EditEventOrganizerProfile from "./feature/admin/EventOrganizer/EditEventOrganizerProfile";
import TradersList from "./feature/admin/Trader/TradersList";
import EditTraderProfile from "./feature/admin/Trader/EditTraderProfile";
import TransactionsList from "./feature/admin/Payments/TransactionsList";
import ManagePayment from "./feature/Organizer/ManagePayment";
import FeedbackList from "./feature/admin/Feedback/FeedbackList";
import PayoutDatePayment from "./feature/Traders/Payout-date-Payment";
import TermsConditions from "./layout/TermsCondition";
import PrivacyPolicy from "./layout/PrivacyPolicy";
import Pricing from "./feature/Common/Pricing";
import TraderProfile from "./feature/Traders/TraderProfile";
import EventDetail from "./feature/Event/Event-Detail";
import About from "./layout/About";
import TicketList from "./feature/Organizer/Tickets/TicketList";
import CreateTicket from "./feature/Organizer/Tickets/CreateTicket";
import NotificationPopup from "./feature/Common/Notification ";
import ShopFrontList from "./feature/Event/Shopfront/ShopFrontList";
import CreateShopFront from "./feature/Event/Shopfront/CreateShopFront";
import MessageDashboard from "./feature/Message/MessageDashboard";
import MessageBox from "./feature/Message/MessageBox";
import Inbox from "./feature/Message/Inbox";

import PostSale from "./feature/Event/PostSales/PostSale";
import ManageStaticPageContent from "./feature/admin/ManageStaticPage/ManageStaticPageContent";
import Faq from "./feature/admin/Faq/Faq";
import FaqAdd from "./feature/admin/Faq/FaqAdd";
import FAQComponent from "./layout/FAQ";
import FeedBackReport from "./feature/Organizer/Reports/feedBackReport";
import ReportDashboard from "./feature/Event/Report-Dashboard";
import FinancialTransactionReports from "./feature/Organizer/Reports/FinancialTransactionReports";
import FinancialTraderReports from "./feature/Organizer/Reports/FinancialTraderReport";
import PrivateRoutesAdmin from "./utils/PrivateRoutesAdmin";
import TicketTransaction from "./feature/Organizer/Reports/TicketTransaction";
import EventGlobalSettings from "./feature/Event/GlobalSettings/GlobalSettings";
import GroupMessageBox from "./feature/Message/GroupMessageBox";
import TraderUnitList from "./feature/Traders/TraderUnits/TraderUnitList";
import CreateTraderUnit from "./feature/Traders/TraderUnits/CreateTraderUnit";
import UnitDashboard from "./feature/Traders/TraderUnits/UnitDashboard";
import TraderUnitShopfront from "./feature/Traders/TraderUnits/TraderUnitShopfront";
import TraderUnitDocument from "./feature/Traders/TraderUnits/TraderUnitDocument";
import AddTraderUnitDocument from "./feature/Traders/TraderUnits/AddTraderUnitDocument";
import CatersPitchDetails from "./feature/Event/CatersPitch/CatersPitchDetails";
import CreateCatersPitch from "./feature/Event/CatersPitch/CreateCatersPitch";
import PaymentTermsandcondition from "./feature/Common/PayementTermsandcondition";
import UserTicketRedeem from "./feature/Organizer/Tickets/UserTicketRedeem";
import TicketTransactionAdmin from "./feature/admin/Payments/TicketTransactionAdmin";
import SubscriptionEnquiry from "./feature/admin/Subscription/SubscriptionEnquiry";
//import EventManagement from "./feature/admin/Event/EventManagement";
import ManageUserAccount from "./feature/admin/Users/ManageUserAccount";
import EventListApproval from "./feature/admin/Event/EventListApproval";
import SalesSummaryPitchReport from "./feature/Organizer/Reports/SalesSummaryPitchReport";
import HtmlToPdf from "./feature/admin/Faq/HtmlToPdf";
import TraderShopFront from "./layout/Traders/TraderShopFront";
import PitchSalesReportAdmin from "./feature/admin/Payments/PitchSalesReportAdmin";
import InvoiceAdmin from "./feature/admin/Payments/InvoiceAdmin";
import { initGlobalErrorHandler } from "./utils/errorLogger";
import UserEmailChangeVerification from "./auth/UserEmailChangeVerification";
import ErrorPage from "./layout/ErrorPage";

function App() {
  const queryClient = new QueryClient();
  initGlobalErrorHandler();

  function TrackPageView() {
    const location = useLocation();

    useEffect(() => {
      if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
          page_path: location?.pathname + location?.search,
        });
      } else {
        console.warn("gtag not loaded yet.");
      }
    }, [location]);

    return null;
  }

  const adminRoutes = () => {
    return (
      <>
        <Route
          path={routes.ADMIN_EVENT_ORGANIZER_LIST}
          element={
            <AdminLayout>
              <EventOrganizerList></EventOrganizerList>
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_NOTIFICATION}
          element={
            <AdminLayout>
              <NotificationPopup />
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_TRADER_SHOP_FRONT}
          element={
            <AdminLayout>
              <TraderShopFront />
            </AdminLayout>
          }
        />

        <Route
          path={routes.ADMIN_EDIT_EVENT_ORGANIZER_PROFILE}
          element={
            <AdminLayout>
              <EditEventOrganizerProfile></EditEventOrganizerProfile>
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_TRADERS_LIST}
          element={
            <AdminLayout>
              <TradersList></TradersList>
            </AdminLayout>
          }
        />

        <Route
          path={routes.ADMIN_EDIT_TRADER}
          element={
            <AdminLayout>
              <EditTraderProfile></EditTraderProfile>
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_MANAGE_EVENTS}
          element={
            <AdminLayout>
              <EventListApproval></EventListApproval>
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_MANAGE_USERS}
          element={
            <AdminLayout>
              <ManageUserAccount />
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_TRANSACTIONS_LIST}
          element={
            <AdminLayout>
              <TransactionsList></TransactionsList>
            </AdminLayout>
          }
        />

        <Route
          path={routes.ADMIN_FEEDBACKS_LIST}
          element={
            <AdminLayout>
              <FeedbackList></FeedbackList>
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_GLOBALSETTINGS}
          element={
            <AdminLayout>
              <GlobalSettings />
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_DASHBOARD}
          element={
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_PROFILE}
          element={
            <AdminLayout>
              <Profile />
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_INQUIRY}
          element={
            <AdminLayout>
              <InquiryList />
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_EVENT_CATEGORY}
          element={
            <AdminLayout>
              <EventCategory />
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_DOCUMENT_TYPE}
          element={
            <AdminLayout>
              <DocumentTypeMaster />
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_TICKET_TRANSACTION_REPORT}
          element={
            <AdminLayout>
              <TicketTransactionAdmin />
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_INVOICE}
          element={
            <AdminLayout>
              <InvoiceAdmin />
            </AdminLayout>
          }
        />

        <Route
          path={routes.ADMIN_PITCH_TRANSACTION_REPORT}
          element={
            <AdminLayout>
              <PitchSalesReportAdmin />
            </AdminLayout>
          }
        />

        {/* Subscription */}
        <Route
          path={routes.ADMIN_SUBSCRIPTION}
          element={
            <AdminLayout>
              <Subscription />
            </AdminLayout>
          }
        />
        <Route
          path={routes.ADMIN_SUB_ENQ}
          element={
            <AdminLayout>
              <SubscriptionEnquiry />
            </AdminLayout>
          }
        />

        {/* Manage Contract */}
        <Route
          path={routes.ADMIN_CONTRACT}
          element={
            <AdminLayout>
              <Contract />
            </AdminLayout>
          }
        />

        {/* Static Page Content */}
        <Route
          path={routes.ADMIN_STATICPAGE}
          element={
            <AdminLayout>
              <ManageStaticPageContent />
            </AdminLayout>
          }
        />

        {/* FAQ */}
        <Route
          path={routes.ADMIN_FAQ_LIST}
          element={
            <AdminLayout>
              <Faq />
            </AdminLayout>
          }
        />

        <Route
          path={routes.ADMIN_FAQ_EDIT}
          element={
            <AdminLayout>
              <FaqAdd />
            </AdminLayout>
          }
        />
      </>
    );
  };

  return (
    <QueryClientProvider client={queryClient}>
      {/* <WagmiProvider config={config}> */}
      <BrowserRouter>
        <ScrollToTop>
          <ToastContainer autoClose={8000}  limit={3}/>
          <LoaderFile />
          <VerifyCodePopup></VerifyCodePopup>
          <TrackPageView />
          <Routes>
            <Route path={routes.ADMIN_LOGIN} element={<AdminLogin />} />
            <Route
              path={routes.DEFAULT}
              element={
                <MainLayout>
                  <HomePage />
                </MainLayout>
              }
            />
             <Route
              path={routes.DEFAULT_LOGIN}
              element={
                <MainLayout>
                  <HomePage />
                </MainLayout>
              }
            />   
            <Route
              path={routes.DEFAULT_LOGIN+ "/:urlRole"}
              element={
                <MainLayout>
                  <HomePage />
                </MainLayout>
              }
            />                
            <Route
              path={routes.GLOBAL_EVENTS}
              element={
                <MainLayout>
                  <EventsListPage></EventsListPage>
                </MainLayout>
              }
            />
            <Route element={<PrivateRoutesAdmin />}>{adminRoutes()}</Route>
            {/* <Route path={routes.SIGNIN} element={<Login />} />
          <Route path={routes.FORGOTPASSWORD} element={<ForgotPassword />} />
          <Route path={routes.SIGNUP} element={<SignUp />} /> */}
            <Route
              path={routes.RESETPASSWORD + "/:token"}
              element={<ResetPassword />}
            />
            <Route
              path={routes.USEREMAILVERIFICATION + "/:token"}
              element={
                <MainLayout>
                  <UserEmailVerification />
                </MainLayout>
              }
            />
  <Route
              path={routes.RESETEMAIL + "/:token"}
              element={
                <MainLayout>
                  <UserEmailChangeVerification />
                </MainLayout>
              }
            />
            <Route
              path={routes.REDEEM_USER_TICKET + "/:order"}
              element={
                <MainLayout>
                  <UserTicketRedeem />
                </MainLayout>
              }
            />

            <Route element={<PrivateRoutes />}>
              <Route
                path={routes.EVENT_POST_DATA}
                element={
                  <MainLayout>
                    <AccountHeader title="Audience Sales & Past Sales Data" />
                    <EventDashboard>
                      <PostSale />
                    </EventDashboard>
                  </MainLayout>
                }
              />
            </Route>

            <Route element={<PrivateRoutes />}>
              <Route
                path={routes.ACCOUNT_DASHBOARD}
                element={
                  <MainLayout>
                    <AccountHeader title="Accounts" />
                    <AccountDashboard />
                  </MainLayout>
                }
              />
              <Route
                path={routes.ACCOUNT_PERSONALINFO}
                element={
                  <MainLayout>
                    <AccountHeader title="Personal Info" />
                    <PersonalInfo />
                  </MainLayout>
                }
              />
              <Route
                path={routes.ACCOUNT_BUSINESSINFO}
                element={
                  <MainLayout>
                    <AccountHeader title="Business Info" />
                    <BusinessProfile />
                  </MainLayout>
                }
              />
              <Route
                path={routes.ACCOUNT_EVENTS}
                element={
                  <MainLayout>
                    <AccountHeader title="My Events" />

                    <EventList />
                  </MainLayout>
                }
              />

              {/* ShopFront Routes */}
              <Route
                path={routes.EVENT_SHOPFRONT_LIST}
                element={
                  <MainLayout>
                    <AccountHeader title="Manage your Menus & Products" />
                    <ShopFrontList />
                  </MainLayout>
                }
              />

              {/* Reports DashBoard */}
              <Route
                path={routes.EVENT_REPORT_DASHBOARD}
                element={
                  <MainLayout>
                    <AccountHeader title="Reports" />
                    <ReportDashboard></ReportDashboard>
                  </MainLayout>
                }
              />
              {/*FeedBack Reports */}
              <Route
                path={routes.EVENT_FEEDBACK_REPORTS}
                element={
                  <MainLayout>
                    <AccountHeader title="Reports" />
                    <ReportDashboard>
                      <FeedBackReport />
                    </ReportDashboard>
                  </MainLayout>
                }
              />

              {/*Financial EO Transactions Reports  */}
              {/* {RolePermission.isAccess(
                loginUser?.role,
                EventActionType.EoFinansialReport
              ) ? ( */}
              <Route
                path={routes.EVENT_PITCH_SALE_REPORTS}
                element={
                  <MainLayout>
                    <AccountHeader title="Reports" />
                    <ReportDashboard>
                      <SalesSummaryPitchReport />
                    </ReportDashboard>
                  </MainLayout>
                }
              />
              {/* ) : (
                <></>
              )} */}
              {/* {RolePermission.isAccess(
                loginUser?.role,
                EventActionType.EoFinansialReport
              ) ? ( */}
              <Route
                path={routes.EVENT_TRANSACTION_REPORTS}
                element={
                  <MainLayout>
                    <AccountHeader title="Reports" />
                    <ReportDashboard>
                      <FinancialTransactionReports />
                    </ReportDashboard>
                  </MainLayout>
                }
              />
              {/* ) : (
                <></>
              )} */}

              {/*Financial Trader Transactions Reports  */}
              {/* {RolePermission.isAccess(
                loginUser?.role,
                AccountActionType.TraderReport
              ) ? ( */}
              <Route
                path={routes.EVENT_TRADER_REPORTS}
                element={
                  <MainLayout>
                    <AccountHeader title="Reports" />
                    <ReportDashboard>
                      <FinancialTraderReports />
                    </ReportDashboard>
                  </MainLayout>
                }
              />
              {/* ) : (
                <></>
              )} */}

              {/* Ticket Tranction Reprts*/}
              {/* {RolePermission.isAccess(
                loginUser?.role,
                EventActionType.TicketFinansialReports
              ) ? ( */}
              <Route
                path={routes.EVENT_TICKET_TRANSACTION_REPORTS}
                element={
                  <MainLayout>
                    <AccountHeader title="Reports" />
                    <ReportDashboard>
                      <TicketTransaction />
                    </ReportDashboard>
                  </MainLayout>
                }
              />
              {/* ) : (
                <></>
              )} */}

              <Route
                path={routes.CREATE_ADD_SHOPFRONT}
                element={
                  <MainLayout>
                    <AccountHeader title="Manage your Menus & Products" />
                    <CreateShopFront />
                  </MainLayout>
                }
              />

              <Route
                path={routes.CREATE_EDIT_SHOPFRONT}
                element={
                  <MainLayout>
                    <AccountHeader title="Manage your Menus & Products" />
                    <CreateShopFront />
                  </MainLayout>
                }
              />

              <Route
                path={routes.ACCOUNT_APPLICATIONS}
                element={
                  <MainLayout>
                    <AccountHeader title="My Applications" />
                    <ApplicationList />
                  </MainLayout>
                }
              />
              <Route
                path={routes.ACCOUNT_CREATE_EVENT}
                element={
                  <MainLayout>
                    <AccountHeader title="My Events" />
                    <CreateEvent />
                  </MainLayout>
                }
              />
              <Route
                path={routes.RETAIL_APPLICATION_FORM}
                element={
                  <MainLayout>
                    <RetailApplicationForm />
                  </MainLayout>
                }
              />
              <Route
                path={routes.CATER_APPLICATION_FORM}
                element={
                  <MainLayout>
                    <CaterApplicationForm />
                  </MainLayout>
                }
              />
              <Route
                path={routes.EVENT_CREATE_APPLICATION}
                element={
                  <MainLayout>
                    <AccountHeader title="Create Application" />
                    <EventDashboard>
                      <AddEventApplication />
                    </EventDashboard>
                  </MainLayout>
                }
              />
              <Route
                path={routes.ACCOUNT_EDIT_EVENT}
                element={
                  <MainLayout>
                    <AccountHeader title="My Events" />
                    <EventDashboard>
                      <CreateEvent />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              {/* Event Contract */}
              <Route
                path={routes.Event_CONTRACT}
                element={
                  <MainLayout>
                    <AccountHeader title="Trader Contract & Communications Templates" />
                    <EventDashboard>
                      <EventContract />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              <Route
                path={routes.Event_EDIT_CONTRACT}
                element={
                  <MainLayout>
                    <AccountHeader title="Trader Contract & Communications Templates" />
                    <EventDashboard>
                      <EditEventContact />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              {/* Event Document */}
              <Route
                path={routes.EVENT_DOCUMENT}
                element={
                  <MainLayout>
                    <AccountHeader
                      title="Upload Trader Contract & Communication 
Documentation"
                    />
                    <EventDashboard>
                      <EventDocument />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              <Route
                path={routes.EVENT_CREATE_DOCUMENT}
                element={
                  <MainLayout>
                    <AccountHeader
                      title="Upload Trader Contract & Communication 
Documentation"
                    />
                    <EventDashboard>
                      <CreateDocument />
                    </EventDashboard>
                  </MainLayout>
                }
              />
              <Route
                path={routes.EVENT_CREATE1_DOCUMENT}
                element={
                  <MainLayout>
                    <AccountHeader
                      title="Upload Trader Contract & Communication 
Documentation"
                    />
                    <EventDashboard>
                      <CreateDocument />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              {/* Event MAp */}
              <Route
                path={routes.EVENT_MAP}
                element={
                  <MainLayout>
                    <AccountHeader title="Site Plan" />
                    <EventDashboard>
                      <EventMap />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              {/*EVENT GLOBAL SETTINGS */}
              <Route
                path={routes.EVENT_GLOBAL_SETTINGS_LIST}
                element={
                  <MainLayout>
                    <AccountHeader title="Global Settings" />
                    <EventDashboard>
                      <EventGlobalSettings />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              {/* Retails Pitch*/}
              <Route
                path={routes.ACCOUNT_PITCHES}
                element={
                  <MainLayout>
                    <AccountHeader title="Create Individual Pitches" />
                    <EventDashboard>
                      <PitchDetails />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              <Route
                path={routes.ACCOUNT_CREATE_PITCH}
                element={
                  <MainLayout>
                    <AccountHeader title="Create Individual Pitches" />
                    <EventDashboard>
                      <CreatePitch />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              <Route
                path={routes.ACCOUNT_EDIT_PITCH}
                element={
                  <MainLayout>
                    <AccountHeader title="Create Individual Pitches" />
                    <EventDashboard>
                      <CreatePitch />
                    </EventDashboard>{" "}
                  </MainLayout>
                }
              />

              {/* Caters Pitch*/}
              <Route
                path={routes.CATERS_ACCOUNT_PITCHES}
                element={
                  <MainLayout>
                    <AccountHeader title="Units" />
                    <EventDashboard>
                      <CatersPitchDetails />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              <Route
                path={routes.CATERS_ACCOUNT_CREATE_PITCH}
                element={
                  <MainLayout>
                    <AccountHeader title="Units" />
                    <EventDashboard>
                      <CreateCatersPitch />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              <Route
                path={routes.CATERS_ACCOUNT_EDIT_PITCH}
                element={
                  <MainLayout>
                    <AccountHeader title="Units" />
                    <EventDashboard>
                      <CreateCatersPitch />
                    </EventDashboard>{" "}
                  </MainLayout>
                }
              />

              <Route
                path={routes.SUBMISSION_CATERER}
                element={
                  <MainLayout>
                    <AccountHeader title="Applications Received" />
                    <EventDashboard>
                      <EventCatererSubmissionList />
                    </EventDashboard>
                  </MainLayout>
                }
              />
              <Route
                path={routes.SUBMISSION_RETAILER}
                element={
                  <MainLayout>
                    <AccountHeader title="Applications Received" />
                    <EventDashboard>
                      <EventTraderSubmissionList />
                    </EventDashboard>
                  </MainLayout>
                }
              />

              <Route
                path={routes.SUBMISSION_CATERER_DETAILS}
                element={
                  <MainLayout>
                    <AccountHeader title="View Details" />
                    <EventDashboard>
                      <EventCatererSubmissionDetails />
                    </EventDashboard>
                  </MainLayout>
                }
              />
              <Route
                path={routes.SUBMISSION_RETAILER_DETAILS}
                element={
                  <MainLayout>
                    <AccountHeader title="View Details" />
                    <EventDashboard>
                      <EventRetailerSubmissionDetails />
                    </EventDashboard>
                  </MainLayout>
                }
              />
              <Route
                path={routes.EVENT_DETAILS}
                element={
                  <MainLayout>
                    <AccountHeader title="View Event Details" />
                    <EventDashboard>
                      <EventDetail />
                    </EventDashboard>
                  </MainLayout>
                }
              />
              <Route
                path={routes.NOTIFICATION_LIST}
                element={
                  <MainLayout>
                    <AccountHeader title="Notifications" />
                    <NotificationPopup />
                  </MainLayout>
                }
              />

              <Route
                path={routes.MANAGE_PAYMENT_TERMS}
                element={
                  <MainLayout>
                    <PaymentTermsandcondition />
                  </MainLayout>
                }
              />

              <Route
                path={routes.SUBMISSION_CATERER_DETAILS_TRADER}
                element={
                  <MainLayout>
                    <AccountHeader title="View Details" />
                    <EventCatererSubmissionDetails />
                  </MainLayout>
                }
              />
              <Route
                path={routes.SUBMISSION_RETAILER_DETAILS_TRADER}
                element={
                  <MainLayout>
                    <AccountHeader title="View Details" />
                    <EventRetailerSubmissionDetails />
                  </MainLayout>
                }
              />
              <Route
                path={routes.EVENT_TICKETS}
                element={
                  <MainLayout>
                    <AccountHeader title="Ticket insights" />
                    <EventDashboard>
                      <TicketList />
                    </EventDashboard>
                  </MainLayout>
                }
              />
              <Route
                path={routes.EVENT_CREATE_TICKET}
                element={
                  <MainLayout>
                    <AccountHeader title="Create ticket" />
                    <EventDashboard>
                      <CreateTicket />
                    </EventDashboard>
                  </MainLayout>
                }
              />
              <Route
                path={routes.ACCOUNT_DASHBOARD}
                element={
                  <MainLayout>
                    <AccountHeader />
                    <AccountDashboard />
                  </MainLayout>
                }
              />

              <Route
                path={routes.ACCOUNT_SUBSCRIPTIONPLANS}
                element={
                  <MainLayout>
                    <SubscriptionList />
                  </MainLayout>
                }
              />
              <Route
                path={routes.ACCOUNT_ACTIVESUBSCRIPTIONP}
                element={
                  <MainLayout>
                    <AccountHeader title="Subscription" />
                    <ActiveSubscription />
                  </MainLayout>
                }
              />
              <Route
                path={routes.ACCOUNT_MANAGE_PAYMENT}
                element={
                  <MainLayout>
                    <AccountHeader title="Payments & payouts" />
                    <ManagePayment />
                  </MainLayout>
                }
              />

               <Route
              path={routes.MESSAGE_INBOX}
              element={
                <MainLayout>
                  <MessageDashboard>
                    <Inbox />
                  </MessageDashboard>
                </MainLayout>
              }
            />
            <Route
              path={routes.MESSAGE_LIST}
              element={
                <MainLayout>
                  <MessageDashboard>
                    <MessageBox />
                  </MessageDashboard>
                </MainLayout>
              }
            />
            <Route
              path={routes.GROUP_MESSAGE_LIST}
              element={
                <MainLayout>
                  <MessageDashboard>
                    <GroupMessageBox />
                  </MessageDashboard>
                </MainLayout>
              }
            />
            </Route>

            <Route
              path={routes.EVENT_APPLICATION_LANDING}
              element={
                <MainLayout>
                  <ApplicationLanding />
                </MainLayout>
              }
            />
            {/* command routes */}
            <Route
              path={routes.ADD_INQUIRY}
              element={
                <MainLayout>
                  <Inquiry />
                </MainLayout>
              }
            />
            <Route
              path={routes.ACCOUNT_DASHBOARD}
              element={
                <MainLayout>
                  <AccountHeader />
                  <AccountDashboard />
                </MainLayout>
              }
            />
            <Route
              path={routes.EVENT_PAGE + "/:eventurl"}
              element={
                <MainLayout>
                  <EventPage />
                </MainLayout>
              }
            />
            <Route
              path={routes.TRADER_PROFILE}
              element={
                <MainLayout>
                  <TraderProfile></TraderProfile>
                </MainLayout>
              }
            />
            <Route
              path={routes.TERMS_CONDITION}
              element={
                <MainLayout>
                  <TermsConditions />
                </MainLayout>
              }
            />
            <Route
              path={routes.PRIVACY_POLICY}
              element={
                <MainLayout>
                  <PrivacyPolicy />
                </MainLayout>
              }
            />
            <Route
              path={routes.ABOUT_US}
              element={
                <MainLayout>
                  <About />
                </MainLayout>
              }
            />

            <Route
              path={routes.EVENT_FAQ}
              element={
                <MainLayout>
                  <FAQComponent />
                </MainLayout>
              }
            />
            <Route
              path={routes.TEST_PDF}
              element={
                <MainLayout>
                  <HtmlToPdf />
                </MainLayout>
              }
            />
            <Route
              path={routes.ERROR_PAGE}
              element={
                // <MainLayout>
                  <ErrorPage />
                // </MainLayout>
              }
            />

            <Route
              path="*"
              element={
                <MainLayout>
                  <NotFound />
                </MainLayout>
              }
            />
            <Route
              path={routes.TRADERS_PAY + "/:token"}
              element={<PayoutDatePayment />}
            />
            <Route
              path={routes.TRADERS_INITIAL_PAY + "/:token"}
              element={<PayoutDatePayment />}
            />
            <Route
              path={routes.PRICING}
              element={
                <MainLayout>
                  <Pricing />
                </MainLayout>
              }
            />
           

            <Route
              path={routes.TRADER_UNIT_LIST}
              element={
                <MainLayout>
                  <AccountHeader title="Shop Front/Manage Units" />
                  <TraderUnitList />
                </MainLayout>
              }
            />
            <Route
              path={routes.CREATE_TRADER_UNIT}
              element={
                <MainLayout>
                  <AccountHeader title="Shop Front/Manage Units" />
                  <CreateTraderUnit />
                </MainLayout>
              }
            />
            <Route
              path={routes.CREATE_TRADER_UNIT}
              element={
                <MainLayout>
                  <AccountHeader title="Add Unit" />
                  <CreateTraderUnit />
                </MainLayout>
              }
            />
            <Route
              path={routes.EDIT_TRADER_UNIT}
              element={
                <MainLayout>
                  <AccountHeader title="Edit Unit" />
                  <UnitDashboard>
                    <CreateTraderUnit />
                  </UnitDashboard>
                </MainLayout>
              }
            />
            <Route
              path={routes.TRADER_UNIT_SHOPFRONT}
              element={
                <MainLayout>
                  <AccountHeader title="Unit Shopfront" />
                  <UnitDashboard>
                    <TraderUnitShopfront />
                  </UnitDashboard>
                </MainLayout>
              }
            />

            <Route
              path={routes.TRADER_UNIT_DOCUMENT}
              element={
                <MainLayout>
                  <AccountHeader title="Unit Documents" />
                  <UnitDashboard>
                    <TraderUnitDocument />
                  </UnitDashboard>
                </MainLayout>
              }
            />
            <Route
              path={routes.TRADER_UNIT_CREATE_DOCUMENT}
              element={
                <MainLayout>
                  <AccountHeader title="Unit Documents" />
                  <UnitDashboard>
                    <AddTraderUnitDocument />
                  </UnitDashboard>
                </MainLayout>
              }
            />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
